import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SignupService } from '../../services/signup.service';
import { SignupInterface } from '../../signup';
import { TranslateService } from '@ngx-translate/core';
import { FormValidatorService } from '../../../../shared/services/form-validator.service';
import { Validators } from '../../../../shared/validators';
import { CustomValidators } from '../../../../shared/custom-validators';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from 'src/app/shared/services/language.service';
import { ReCaptchaService } from 'angular-recaptcha3';
import Swal from 'sweetalert2';
import { LoginService } from '../../services/login.service';
declare let $: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})

export class SignupComponent implements OnInit {
  signupForm!: FormGroup;
  validationError!: [
    {
      field: string;
      message: string;
      validation: string;
    }
  ];
  referralCode: string = '';
  initialUrlPath: string = '';
  notOnlyNumPattern = /(?!^\d+$)^.+$/g;
  onlyNumberPattern = /^[0-9]*$/g;
  textOnlyPattern = /(^[a-z ]+$)/i;
  noSpacesPattern = /^\S*$/;
  currentLanguage: string;

  constructor(
    private signupService: SignupService,
    public formValidator: FormValidatorService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private languageService: LanguageService,
    private recaptchaService: ReCaptchaService,
    private router: Router,
    private login: LoginService,
  ) { }

  ngOnInit() {
    this.initialUrlPath = (this.activatedRoute.snapshot as any)._routerState.url
    this.currentLanguage = localStorage.getItem('language');
    this.translate.use(this.currentLanguage);
    localStorage.setItem('language', this.currentLanguage);
    this.languageService.languageUpdated.emit(this.currentLanguage);
    this.currentLanguage == 'ar'
      ? document.body.classList.add('dir-rtl')
      : document.body.classList.remove('dir-rtl');
    this.signupForm = this.formValidator.createForm([
      {
        fieldName: "first_name",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ""
          },
          {
            validatorFn: Validators.minLength(2),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/^[a-zA-Z0-9]*$/),
            message: this.translate.instant("FORMS.VALIDATION.TEXT_ONLY", {
              field: "first name"
            })
          },
          {
            validatorFn: Validators.maxLength(20),
            message: ''
          },
        ]
      },
      {
        fieldName: "last_name",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ""
          },
          {
            validatorFn: Validators.minLength(2),
            message: ""
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: ""
          },
          {
            validatorFn: CustomValidators.customPattern(/^[a-zA-Z0-9]*$/),
            message: this.translate.instant("FORMS.VALIDATION.TEXT_ONLY", {
              field: "first name"
            })
          },
          {
            validatorFn: Validators.maxLength(20),
            message: ""
          },
        ]
      },
      {
        fieldName: "phone",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: CustomValidators.requiredNumber,
            message: ""
          },
          {
            validatorFn: Validators.minLength(11),
            message: ""
          },
          {
            validatorFn: Validators.maxLength(11),
            message: ""
          },
          {
            validatorFn: CustomValidators.customPattern(this.onlyNumberPattern),
            message: this.translate.instant('FormValidation.numbersOnly')
          },
        ]
      },
      {
        fieldName: "email",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: Validators.email,
            message: ''
          }
        ]
      },
      {
        fieldName: "business_name",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: Validators.minLength(2),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: ''
          }
        ]
      },
      {
        fieldName: "password",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: Validators.minLength(8),
            message: ''
          },
          {
            validatorFn: CustomValidators.complexPassword('s'),
            message: ""
          },
        ]
      },
      {
        fieldName: "checkbox",
        defaultValue: false,
        validators: [
          {
            validatorFn: Validators.requiredTrue,
            message: ''
          }
        ]
      },
      {
        fieldName: "referral_code",
        defaultValue: null,
        validators: []
      }
    ]);
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })

    $(".bur-button").on("click", function () {
      $(".header-login-hide").slideToggle(500);
    });
    if (sessionStorage.getItem("referralCode")) {
      this.signupForm.controls["referral_code"].setValue(
        sessionStorage.getItem("referralCode")
      );
    } else {
      this.referralCode = "";
    }
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        first_name: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          minlength: this.translate.instant('FormValidation.MinLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 2
          }),
          maxlength: this.translate.instant('FormValidation.MaxLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 20
          }),
        },
        last_name: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          minlength: this.translate.instant('FormValidation.MinLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 2
          }),
          maxlength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 20
          }),
        },
        password: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Password",
            fieldAr: "كلمة المرور"
          }),
          minlength: this.translate.instant("FormValidation.MinLength", {
            field: "password",
            fieldAr: "كلمة المرور",
            value: 8
          }),
          complexPassword:this.translate.instant("FormValidation.complexPassword", {
            field: "password",
            fieldAr: "كلمة المرور",
          }),
        },
        phone: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Phone",
            fieldAr: "رقم الهاتف"
          }),
          minlength: this.translate.instant('FormValidation.MinLength', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
            value: 11
          }),
          maxlength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
            value: 11
          }),
          requiredNumber: this.translate.instant('FormValidation.RequiredNumber'),
          customPattern: this.translate.instant('FormValidation.numbersOnly', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
          }),
        },
        email: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Email",
            fieldAr: "البريد الاكتروني"
          }),
          email: this.translate.instant("FormValidation.ValidEmail", {
            field: "email",
            fieldAr: "البريد الاكتروني"
          }),
        },
        business_name: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business name',
            fieldAr: 'الإسم التجاري'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'Business name',
            fieldAr: 'الإسم التجاري'
          }),
          minlength: this.translate.instant('FormValidation.MinLength', {
            field: 'Business name',
            fieldAr: 'الإسم التجاري',
            value: 2
          }),
        },
        checkbox: {
          requiredTrue: this.translate.instant('FormValidation.AcceptTerms'),
        },
      }
    });
  }

  async onSignup(signupValues: SignupInterface) {
	  this.currentLanguage = localStorage.getItem('language');
	  let title = 'Only Sellers Need an Account';
	  let text = `Did you know that you don't need an account to buy anything on Easykash?
	  Only Sellers need an account`;
	  let confirmButtonText = 'Create a Seller Account';
	  let cancelButtonText = 'Cancel';

	  if(this.currentLanguage === 'ar') {
		  title = 'يحتاج البائعون فقط إلى حساب';
		  text = `هل تعلم أنك لست بحاجة إلى حساب لشراء أي شيء على EasyKash؟ يحتاج البائعون فقط إلى حساب`;
		  confirmButtonText = 'إنشاء حساب البائع';
		  cancelButtonText = 'الغاء';
	  }

	const confimPopup = await Swal.fire({
		title,
		text,
		icon: 'info',
		showCancelButton: true,
		confirmButtonText,
		cancelButtonText,
	})
	if (confimPopup.isConfirmed) {
		this.createSellerAccount(signupValues);
		return;
	}
	this.router.navigate(['/']);
  }

  private async createSellerAccount(signupValues: SignupInterface) {
    console.log("Sign up values", signupValues);
    const phoneNum = signupValues.phone;
    signupValues["phone"] = phoneNum;

    const { pathname, search } = window.location;
    signupValues['ref'] = this.initialUrlPath
      ? this.initialUrlPath
      : pathname + search;

    try {
      const recaptchaToken = await this.recaptchaService.execute({
        action: 'signup',
      });
      const recaptchaTokenLogin = await this.recaptchaService.execute({
        action: 'login',
      });
      this.signupService.setParams({ ...signupValues, recaptchaToken });
      await this.signupService.signUp();
      this.login.setParams({
        email: signupValues.email,
        password: signupValues.password,
        recaptchaToken: recaptchaTokenLogin,
      });
      await this.login.make();
      this.router.navigate(['/user/mobile-verification']);
    } catch (errors) {
      console.log(errors);
      this.validationError = errors.validationErrors.error;
      for (const e of this.validationError) {
        this.formValidator.addError(e.field, "invalid", e.message);
        this.signupForm.controls[e.field].setErrors({ invalid: e.message });
        this.formValidator.ShowErrors();
      }
    }
  }
}
